'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _ProjectTypeIcon = require('components/ProjectTypeIcon/ProjectTypeIcon');

var _ProjectTypeIcon2 = _interopRequireDefault(_ProjectTypeIcon);

var _utils = require('helpers/utils');

var _Tooltip = require('components/Tooltip/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectTypeTooltip = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(ProjectTypeTooltip, _PureComponent);

  function ProjectTypeTooltip() {
    (0, _classCallCheck3.default)(this, ProjectTypeTooltip);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectTypeTooltip.__proto__ || (0, _getPrototypeOf2.default)(ProjectTypeTooltip)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectTypeTooltip, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          projectType = _props.projectType;


      return _react2.default.createElement(
        _Tooltip2.default,
        {
          placement: 'top',
          title: projectType,
          onClick: _utils.stopEvent
        },
        _react2.default.createElement(_ProjectTypeIcon2.default, { className: (0, _bind2.default)(className), type: projectType })
      );
    }
  }]);
  return ProjectTypeTooltip;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  projectType: _propTypes2.default.string
}, _temp);
exports.default = ProjectTypeTooltip;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectTypeTooltip/ProjectTypeTooltip.js
// module id = 2062
// module chunks = 1